import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import Slider from "nx-components/Slider";
import prefixStyles from "nx-components/utils/prefixStyles";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import CommonControlWrapper from "nexia_mobile/components/Controls/wrappers/CommonControlWrapper";

const sliderStyle = prefixStyles({ flex: "1 0 auto", margin: "1em 0.5em" });

export default class WindowShadeSetPercentOpen extends React.Component {
  static propTypes = {
    model: PropTypes.instanceOf(Backbone.Model).isRequired,
    isDetailed: PropTypes.bool.isRequired,
    showSpinner: PropTypes.func.isRequired, // (?string) => void
    hideSpinner: PropTypes.func.isRequired, // () => void
  };

  state = {
    pendingValue: null,
  };

  _handleDragStart = () => Dispatch("DISABLE_LOCATION_POLLING");

  _handleDragEnd = (value) => {
    const { model, showSpinner, hideSpinner } = this.props;

    if (value !== model.get("percent_open")) {
      // don't set percent open if it hasn't changed
      this.setState({ pendingValue: value });
      showSpinner(`Setting '${model.get("name")}' to ${value}`);
      const onDone = () => {
        this.setState({ pendingValue: null });
        hideSpinner();
      };
      model.setPercentOpen(value).then(onDone, onDone);
    }
    Dispatch("ENABLE_LOCATION_POLLING");
  };

  render() {
    const { model, isDetailed } = this.props;
    const { pendingValue } = this.state;

    let displayValue = model.get("percent_open") || 0;
    if (pendingValue != null) {
      displayValue = pendingValue;
    }

    return (
      <CommonControlWrapper isDetailed={isDetailed}>
        <Slider
          min={0}
          max={100}
          value={displayValue}
          formatValue={(value) => `${value}%`}
          onDragStart={this._handleDragStart}
          onDragEnd={this._handleDragEnd}
          style={sliderStyle}
        />
      </CommonControlWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Controls/WindowShadeSetPercentOpen.jsx